import React from "react";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";
import { Mail, Phone } from "lucide-react";

const TAB_BAR_ROUTES = ["/", "/services", "/about", "/contact"];

export default function Footer() {
  const loc = useLocation();
  const { t } = useTranslation();
  const hasTabBar = TAB_BAR_ROUTES.includes(loc.pathname);

  return (
    <footer className={`bg-[#1C4532] text-[#FAF9F6] mt-24 ${hasTabBar ? "hide-on-mobile-tab" : ""}`}>
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16 grid grid-cols-1 md:grid-cols-6 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3 font-display text-2xl mb-4">
            <span className="w-10 h-10 overflow-hidden rounded-full bg-black shadow-[0_10px_25px_rgba(0,0,0,0.24)]">
              <img src="/theuniversaltree-logo.jpeg" alt="Universal Tree logo" className="h-full w-full object-cover rounded-full" />
            </span>
Universal Tree
          </div>
          <p className="text-sm text-[#FAF9F6]/70 max-w-md leading-relaxed">
            {t("footer.description")}
          </p>
        </div>

        <div>
          <p className="text-xs uppercase tracking-[0.2em] text-[#D9734E] mb-4">{t("footer.explore")}</p>
          <ul className="space-y-2 text-sm">
            <li><Link to="/services" className="hover:text-[#D9734E] transition-colors">{t("footer.link.services")}</Link></li>
            <li><Link to="/about" className="hover:text-[#D9734E] transition-colors">{t("footer.link.about")}</Link></li>
            <li><Link to="/contact" className="hover:text-[#D9734E] transition-colors">{t("footer.link.contact")}</Link></li>
            <li><Link to="/signup?role=worker" className="hover:text-[#D9734E] transition-colors">{t("footer.link.becomePro")}</Link></li>
          </ul>
        </div>

        <div>
          <p className="text-xs uppercase tracking-[0.2em] text-[#D9734E] mb-4">Policies</p>
          <ul className="space-y-2 text-sm">
            <li><Link to="/page/terms" className="hover:text-[#D9734E] transition-colors">Terms &amp; Conditions</Link></li>
            <li><Link to="/page/privacy" className="hover:text-[#D9734E] transition-colors">Privacy Policy</Link></li>
            <li><Link to="/page/shipping" className="hover:text-[#D9734E] transition-colors">Shipping Policy</Link></li>
            <li><Link to="/page/cancellation" className="hover:text-[#D9734E] transition-colors">Cancellation &amp; Refunds</Link></li>
          </ul>
        </div>

        <div>
          <p className="text-xs uppercase tracking-[0.2em] text-[#D9734E] mb-4">{t("footer.contact")}</p>
          <ul className="space-y-2 text-sm">
            <li className="flex items-center gap-2"><Mail size={14}/> hello@universaltree.io</li>
            <li className="flex items-center gap-2"><Phone size={14}/> +91 80000 12345</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[#FAF9F6]/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-6 text-xs text-[#FAF9F6]/50 flex justify-between">
          <span>{t("footer.copyright")}</span>
          <span className="font-mono">{t("footer.version")}</span>
        </div>
      </div>
    </footer>
  );
}
